<template>
  <v-container>
    <template v-for="cart in $store.state.carts">
      <v-card 
        :key="cart.id" 
        class="mb-3">
        <review-headline :cart="cart" />
        <review-products :cart="cart" />
      </v-card>
    </template>
  </v-container>
</template>
<script>
export default {
	computed: {
		carts() {
			return this.$store.state.carts
		}
	},
	mounted() {
		this.$nextTick(() => {
			this.$vuetify.goTo(0)
			var empty = true
			this.$store.state.carts.forEach(cart => {
				if (cart.products.length > 0) empty = false
			})
			this.$store.state.empty = empty
		})
	}
}
</script>